import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http : HttpClient) { }

  getProfile(){
    return this.http.get<any>(environment.api + '/api/users/user-info')
  }

  updateProfileImage(image){
    let formData = new FormData()
    formData.append('image', image)
    return this.http.put<any>(environment.api+'/api/users/change-profile', formData)
  }

  changePassword(newPassword, oldPassword){
    let params = new HttpParams({
      fromObject: {
        newPassword: newPassword,
        oldPassword: oldPassword
      }
    })
    return this.http.put<any>(environment.api+'/api/users/change-password', params)
  }

  updateUser(user){
    let params = new HttpParams({
      fromObject: user
    })
    return this.http.put<any>(environment.api+'/api/users/update', params)
  }

  addState(data){
  	return this.http.post<any>(environment.api +'/api/provinces/add',data);
  }

  states(){
  	return this.http.get<any>(environment.api + '/api/provinces/getall');
  }

  editState(value,id){
    return this.http.put(environment.api + '/api/provinces/update/'+id,value);
  }

  submitDistricts(data){
  	return this.http.post<any>(environment.api + '/api/districts/add',data);
  }

  districts(){
  	return this.http.get<any>(environment.api + '/api/districts/getall');
  }

  editDistrict(value,id){
    return this.http.put(environment.api + '/api/districts/update/'+id, value);
  }

  deleteDistrict(id){
    return this.http.delete(environment.api + '/api/districts/delete/'+id); 
  }

  submitMunicipality(data){
  	return this.http.post<any>(environment.api + '/api/municipalities/add',data)
  }

  municipalities(){
    return this.http.get<any>(environment.api + '/api/municipalities/getall');
  }

  editMunicipality(value,id){
    return this.http.put(environment.api + '/api/municipalities/update/'+id, value);
  }

  submitPropertyPlan(data){
  	return this.http.post<any>(environment.api + '/api/itemPlans/add',data);
  }

  adPlans(){
    return this.http.get(environment.api + '/api/itemPlans/getall');
  }

  editPlan(value,id){
    let httpParams = new HttpParams({
      fromObject: value
    })
    return this.http.put(environment.api + '/api/itemPlans/update/'+id, httpParams);
  }

  deletePlan(id){
    return this.http.delete(environment.api + '/api/itemPlans/delete/'+id);
  }

  getUsers(offset, sort){
    return this.http.get(environment.api + '/api/users/filter?offset='+offset+'&sort='+sort);
  }

  getUsersByName(name, offset){
    return this.http.get<any>(environment.api + '/api/users/getusers/name/'+name+'?offset='+offset);
  }

  getUserByPhone(phone){
    return this.http.get<any>(environment.api + '/api/users/getone/phone/'+phone);
  }

  getOneUser(id){
    return this.http.get<any>(environment.api + '/api/users/getone/'+id);
  }

  submitBlog(blog){
    let formData = new FormData()
    for(let key in blog){
      if(blog[key]){
        formData.append(key, blog[key])
      }
    }
    return this.http.post<any>(environment.api + '/api/blogs/add', formData);
  }

  submitDraft(blog){
    let formData = new FormData()
    for(let key in blog){
      if(blog[key]){
        formData.append(key, blog[key])
      }
    }
    return this.http.post<any>(environment.api + '/api/blogs/addDraft', formData);
  }

  changeBlogStatus(id){
    return this.http.get<any>(environment.api + '/api/blogs/status-change/'+id);
  }

  getBlog(id){
    return this.http.get<any>(environment.api + '/api/blogs/getone/'+id);
  }

  updateBlog(id, blog){
    let formData = new FormData()
    for(let key in blog){
      formData.append(key, blog[key])
    }
    return this.http.put<any>(environment.api + '/api/blogs/update/'+id, formData);
  }

  updateFeaturedImage(id, image){
    let formData = new FormData()
    formData.append('featuredImage', image)
    return this.http.put<any>(environment.api + '/api/blogs/updateblogimages/'+id, formData);
  }

  updateAuthorImage(id, image){
    let formData = new FormData()
    formData.append('authorImage', image)
    return this.http.put<any>(environment.api + '/api/blogs/updateauthorimage/'+id, formData);
  }

  getBlogs(){
    return this.http.get<any>(environment.api + '/api/blogs/getall');
  }

  deleteBlog(id){
    return this.http.delete<any>(environment.api + '/api/blogs/delete/'+id);
  }

  submitBlogImages(image){
    let formData = new FormData()
    formData.append('contentImage', image)
    return this.http.post<any>(environment.api + '/api/blogs/addcontentimage', formData);
  }

  getPropertyTypes(){
    return this.http.get<any>(environment.api+'/api/property-types/getall')
  }

  addPropertyType(type){
    let params = new HttpParams({
      fromObject: type
    })
    return this.http.post<any>(environment.api+'/api/property-types/add', params)
  }

  updatePropertyType(id, type){
    let params = new HttpParams({
      fromObject: type
    })
    return this.http.put<any>(environment.api+'/api/property-types/update/'+id, params)
  }

  deletePropertyType(id){
    return this.http.delete<any>(environment.api+'/api/property-types/delete/'+id)
  }

  getRoadBlockAd(){
    return this.http.get<any>(environment.api+'/api/roaditems/getall')
  }

  addRoadBlock(roadBlock){
    let formData = new FormData()
    for(let key in roadBlock){
      formData.append(key, roadBlock[key])
    }
    return this.http.post<any>(environment.api+'/api/roaditems/add', formData)
  }

  editRoadBlock(id, roadBlock){
    let formData = new FormData()
    for(let key in roadBlock){
      formData.append(key, roadBlock[key])
    }
    return this.http.put<any>(environment.api+'/api/roaditems/update/'+id, formData)
  }

  deleteRoadBlock(id){
    return this.http.delete<any>(environment.api+'/api/roaditems/delete/'+id)
  }

  getLocalAd(){
    return this.http.get<any>(environment.api+'/api/localitems/getall')
  }

  addLocalAd(roadBlock){
    let formData = new FormData()
    for(let key in roadBlock){
      formData.append(key, roadBlock[key])
    }
    return this.http.post<any>(environment.api+'/api/localitems/add', formData)
  }

  editLocalAd(id, roadBlock){
    let formData = new FormData()
    for(let key in roadBlock){
      formData.append(key, roadBlock[key])
    }
    return this.http.put<any>(environment.api+'/api/localitems/update/'+id, formData)
  }

  deleteLocalAd(id){
    return this.http.delete<any>(environment.api+'/api/localitems/delete/'+id)
  }

  getBannerImages(){
    return this.http.get<any>(environment.api+'/api/homebanners/getall')
  }

  addBannerImage(roadBlock){
    let formData = new FormData()
    for(let key in roadBlock){
      formData.append(key, roadBlock[key])
    }
    return this.http.post<any>(environment.api+'/api/homebanners/add', formData)
  }

  editBannerImage(id, roadBlock){
    let formData = new FormData()
    for(let key in roadBlock){
      formData.append(key, roadBlock[key])
    }
    return this.http.put<any>(environment.api+'/api/homebanners/update/'+id, formData)
  }

  deleteBannerImage(id){
    return this.http.delete<any>(environment.api+'/api/homebanners/delete/'+id)
  }

  getBankVouchers(){
    return this.http.get<any>(environment.api+'/api/bankpayments/getall')
  }

  getProperty(id){
    return this.http.get<any>(environment.api+'/api/property-item/getbyaliasid/'+id)
  }

  verifyBankVouchers(id, status){
    let params = new HttpParams({
      fromObject: {
        status: status
      }
    })
    return this.http.put<any>(environment.api+'/api/bankpayments/verify/'+id, params)
  }

  getTransactions(){
    return this.http.get<any>(environment.api+'/api/transactions/getall')
  }

  verifyTransaction(id, status){
    let params = new HttpParams({
      fromObject: {
        status: status
      }
    })
    return this.http.put<any>(environment.api+'/api/transactions/verify/'+id, params)
  }

  getDashboardInfo(){
    return this.http.get<any>(environment.api+'/api/property-item/statistics')
  }

  getUserStats(){
    return this.http.get<any>(environment.api+'/api/users/dashboard-info')
  }

  getEarningInfo(){
    return this.http.get<any>(environment.api+'/api/property-item/earnings')
  }

  getProperties(status, offset){
    return this.http.get<any>(environment.api+'/api/property-item/getbystatus/'+status+'?offset='+offset)
  }


  updateProfile(user){
    let params = new HttpParams({
      fromObject: user
    })
    return this.http.put<any>(environment.api+'/api/users/update', params)
  }

  editUser(id, user){
    let params = new HttpParams({
      fromObject: user
    })
    return this.http.put<any>(environment.api+'/api/users/edit-user/'+id, params)
  }

  changeUserPassword(id, password){
    let params = new HttpParams({
      fromObject: {
        password: password
      }
    })
    return this.http.put<any>(environment.api+'/api/users/change-user-password/'+id, params)
  }

  deleteUser(id){
    return this.http.delete<any>(environment.api+'/api/users/delete/'+id)
  }

  getAdvertisement(id){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this.http.get<any>(environment.api+'/api/property-item/getone/'+id, httpOptions)
  }

  deleteProperty(id){
    return this.http.delete<any>(environment.api+'/api/property-item/delete/'+id)
  }

  updateProperty(id, property){
    let params = new HttpParams({
      fromObject: property
    })
    return this.http.put<any>(environment.api+'/api/property-item/update/'+id, params)
  }

  changePropertyImage(id, images){
    let formData = new FormData()
    for(let image of images){
      formData.append('images', image)
    }
    return this.http.put<any>(environment.api+'/api/property-item/addimage/'+id, formData)
  }

  deletePropertyImage(id, image){
    return this.http.delete<any>(environment.api+'/api/property-item/deleteimage/'+id+'/'+image)
  }

  searchPropertyByAdmin(searchHeader, searchValue){
    return this.http.get<any>(environment.api+'/api/property-item/search-for-admin?'+searchHeader+'='+searchValue)
  }

  getBankPayment(aliasId){
    return this.http.get<any>(environment.api+'/api/bankpayments/getbyaliasid/'+aliasId)
  }

  updateBankPayment(id, voucher){
    let formData = new FormData()
    for(let key in voucher){
      formData.append(key, voucher[key])
    }
    return this.http.put<any>(environment.api+'/api/bankpayments/update/'+id, formData)
  }

  deleteBankPayment(id){
    return this.http.delete<any>(environment.api+'/api/bankpayments/delete/'+id)
  }

  getTransaction(aliasId){
    return this.http.get<any>(environment.api+'/api/transactions/getbyaliasid/'+aliasId)
  }

  deleteTransaction(id){
    return this.http.delete<any>(environment.api+'/api/transactions/delete/'+id)
  }

  changePropertyStatus(aliasId, status){
    return this.http.get<any>(environment.api+'/api/property-item/change-status?id='+aliasId+'&status='+status)
  }

  updatePaymentDetails(id, details){
    let formData = new FormData()
    for(let key in details){
      formData.append(key, details[key])
    }
    return this.http.post<any>(environment.api+'/api/transactions/edit/'+id, formData)
  }

  savePaymentDetails(details){
    let formData = new FormData()
    for(let key in details){
      formData.append(key, details[key])
    }
    return this.http.post<any>(environment.api+'/api/transactions/add', formData)
  }

  addBankPayment(voucher){
    let formData = new FormData()
    for(let key in voucher){
      formData.append(key, voucher[key])
    }
    return this.http.post<any>(environment.api+'/api/bankpayments/add', formData)
  }


}
